import React from "react"

export interface FormErrorProps {}

const FormError: React.FC<FormErrorProps> = ({ children }) => {
  return <span className="text-error">{children}</span>
}

export default FormError
